import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../Button/Button.styles';
const LinkButton = ({ buttonType, children, fillDirection = 'right', icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: "a", "data-fill": fillDirection, "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-type": buttonType, ...otherProps },
            React.createElement(S.Text, null, children),
            icon && React.createElement(S.IconWrapper, null, icon))));
};
export default LinkButton;
